// extracted by mini-css-extract-plugin
export default {"fields":"EditDocument_fields__lsXXu","btnsContainer":"EditDocument_btnsContainer__s4LhR","hasDueDate":"EditDocument_hasDueDate__3Ak68"};